export default "__VITE_ASSET__sJx31suq__"